import config from '../configs/config';
import Services from '../services/services';
import AuthModel from '../models/authModel';
import ErrorController from '../controllers/errorController';
import {
    debug,
    error,
    info,
    warn,
    isDebug
} from '../../../core/js/utils/logger';
import {
    makeRequest
} from '../../../core/js/sagas/makeRequest';

class AccountService {
    constructor(config) {}

    /**
     * Http Request
     * @param {Object} options
     * {String} method: the type of request (POST, PUT, GET, DELETE, etc)
     * {String} path: the path to the API endpoint to be called
     * {Object} params: optional parameters that may get passed to API
     * {Object} requestBody: used to set headers for some API calls
     * {String} session: the current user's authed session
     * {Object} store: The redux store
     */
    httpRequest(options) {
        const state = options.store.getState();
        // if the users locale is not urban, update the endpoint with the correct locale
        options.path = options.path.replace('fp-us', state.core.siteId);

        const res = options.store.runSaga(makeRequest, options).done.then((res) => {
            const successResponse = {
                status: 200,
                data: res
            };

            return successResponse;
        })
        .catch(err => {
            if (err.status && err.status.code) {
                error(`${err.status.code} ${err.entity.code}: ${err.entity.message}`);
                const statusCode = err.status.code;
                let errorResponse = {};

                if (parseInt(statusCode, 10) !== 404) {
                    ErrorController.handleErrors(err, err.request.model, err.request.viewModel, err.request.controller, undefined, err.request.selector, '', state);
                } else {
                    return err;
                }
            } else {
                return err;
            }
        });

        return res;
    }
}

const accountService = new AccountService(config);
export default accountService;
